"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../../constants/vars"));

var _Input = _interopRequireDefault(require("../../Input"));

var _breakpoints = _interopRequireDefault(require("../../../constants/breakpoints"));

var _DayPartOverlay = _interopRequireDefault(require("./DayPartOverlay"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: ", " !important;\n\tmargin-bottom: 0px !important;\n\t", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: ", " !important;\n\tborder: ", " solid ", ";\n\tborder-radius: ", ";\n\tmargin-top: -", ";\n\tpadding: ", ";\n\tbackground-color: ", ";\n\tbox-shadow: ", ";\n\t", ";\n\n\t@media (min-width: ", ") {\n\t\tposition: absolute;\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var borderColorMixin = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.overlayOpen && "border-color: " + _colors.default.primary + " !important";
});

var Wrapper = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.width;
});

Wrapper.displayName = 'Wrapper';

var OverlayContainer = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.width;
}, _vars.default.borderWidth, _colors.default.grey, _vars.default.borderRadius, _vars.default.borderWidth, _spacing.default.s2, _colors.default.white, _vars.default.boxShadow, borderColorMixin, _breakpoints.default.tablet);

OverlayContainer.displayName = 'OverlayContainer';
var DayPartInput = (0, _styledComponents.default)(_Input.default)(_templateObject4(), function (props) {
  return props.width;
}, borderColorMixin);
DayPartInput.displayName = 'DayPartInput';

var DayPartPicker =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DayPartPicker, _React$Component);

  function DayPartPicker(props) {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.state = {
      options: props.options,
      overlayOpen: false
    };
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = DayPartPicker.prototype;

  _proto.apply = function apply(options) {
    this.setState({
      options: options
    });
    this.toggleOverlay();
    this.props.onDayPartSelect(options);
  };

  _proto.toggleOverlay = function toggleOverlay() {
    var toggle = this.state.overlayOpen;
    this.setState({
      overlayOpen: !toggle
    });
  };

  _proto.handleClickOutside = function handleClickOutside() {
    this.setState({
      overlayOpen: false
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        width = _this$props.width,
        onDayPartSelect = _this$props.onDayPartSelect,
        rest = _objectWithoutPropertiesLoose(_this$props, ["width", "onDayPartSelect"]);

    var _this$state = this.state,
        overlayOpen = _this$state.overlayOpen,
        options = _this$state.options;
    var selected = options.find(function (o) {
      return o.selected;
    });
    return _react.default.createElement(Wrapper, _extends({
      width: width
    }, rest), _react.default.createElement(DayPartInput, {
      value: selected.label,
      overlayOpen: overlayOpen,
      onFocus: function onFocus() {
        if (!overlayOpen) {
          _this2.setState({
            overlayOpen: true
          });
        }
      },
      readOnly: true,
      width: width
    }), overlayOpen && _react.default.createElement(OverlayContainer, {
      "data-testid": "overlay",
      overlayOpen: overlayOpen,
      width: width
    }, _react.default.createElement(_DayPartOverlay.default, {
      options: options,
      onApply: this.apply,
      onCancel: this.toggleOverlay
    })));
  };

  return DayPartPicker;
}(_react.default.Component);

DayPartPicker.displayName = 'DayPartPicker';
DayPartPicker.propTypes = {
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.number,
    label: _propTypes.string,
    duration: _propTypes.string,
    selected: _propTypes.bool,
    disabled: _propTypes.bool
  })).isRequired,
  width: _propTypes.string.isRequired,
  onDayPartSelect: _propTypes.func.isRequired
};

var _default = (0, _reactOnclickoutside.default)(DayPartPicker);

exports.default = _default;